import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Badge, Box, ButtonBase } from '@mui/material';
import { classNames } from 'utils/classnames';
import styles from './side-nav-item.module.scss';

interface SideNavItemProps {
  active: boolean;
  disabled?: boolean;
  external?: boolean;
  alert?: boolean;
  icon?: React.ReactNode;
  path?: string;
  title: string;
  badgeCount?: number;
}

export const SideNavItem = ({
  active = false,
  disabled = false,
  external = false,
  icon = undefined,
  path = undefined,
  title,
  alert = false,
  badgeCount = 0,
}: SideNavItemProps) => {
  let linkProps = {};
  if (path !== undefined) {
    if (external) {
      linkProps = {
        component: 'a',
        href: path,
        target: '_blank',
      };
    } else {
      // RouterLink takes `to`, not `href`. The external (`component: 'a'`)
      // branch above keeps `href` because that's the native anchor prop.
      linkProps = {
        component: RouterLink,
        to: path,
      };
    }
  }

  const buttonClassNames = classNames(styles.navigation_button, active ? styles.active : null);
  const iconContainerClassNames = classNames(
    styles.icon_container,
    active ? styles.active : null,
  );
  const textContainerClassNames = classNames(
    styles.button_text,
    alert ? styles.alert : null,
    active ? styles.active : null,
    disabled ? styles.disabled : null,
  );
  return (
    <li>
      <ButtonBase
        className={buttonClassNames}
        {...linkProps}
      >
        {icon && (
          <Box
            component="span"
            className={iconContainerClassNames}
          >
            {icon}
          </Box>
        )}
        <Box
          component="span"
          className={textContainerClassNames}
          sx={{
            fontFamily: (theme) => theme.typography.fontFamily,
            flexGrow: 1,
          }}
        >
          {title}
        </Box>
        {badgeCount > 0 && (
          <Badge
            badgeContent={badgeCount}
            color="primary"
            sx={{ mr: 1.5 }}
          />
        )}
      </ButtonBase>
    </li>
  );
};
